import React from 'react';
import { UserCircleIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { FaWhatsapp } from 'react-icons/fa';
import { Volume2 } from 'lucide-react';
var SettingsTabs = function (_a) {
    var activeTab = _a.activeTab, onTabChange = _a.onTabChange;
    var tabs = [
        {
            id: 'profile',
            label: 'Perfil',
            icon: React.createElement(UserCircleIcon, { className: "w-5 h-5" }),
            color: 'blue',
            gradient: 'from-blue-500 to-blue-700'
        },
        {
            id: 'agency',
            label: 'Agência',
            icon: React.createElement(BuildingOffice2Icon, { className: "w-5 h-5" }),
            color: 'cyan',
            gradient: 'from-cyan-500 to-cyan-700'
        },
        {
            id: 'whatsapp',
            label: 'WhatsApp',
            icon: React.createElement(FaWhatsapp, { className: "w-5 h-5" }),
            color: 'green',
            gradient: 'from-green-500 to-green-700'
        },
        {
            id: 'audio',
            label: 'Alertas Sonoros',
            icon: React.createElement(Volume2, { className: "w-5 h-5" }),
            color: 'purple',
            gradient: 'from-purple-500 to-purple-700'
        },
    ];
    return (React.createElement("div", { className: "flex flex-wrap justify-center gap-3 mb-2 md:mb-8" }, tabs.map(function (tab) { return (React.createElement("button", { key: tab.id, "data-tab": tab.id, onClick: function () { return onTabChange(tab.id); }, className: "group relative flex items-center gap-3 px-6 py-3 rounded-xl font-semibold transition-all duration-300 overflow-hidden ".concat(activeTab === tab.id
            ? "bg-gradient-to-r ".concat(tab.gradient, " text-white shadow-lg scale-105")
            : 'bg-gray-800/60 text-gray-400 hover:bg-gray-700/80 hover:text-white border border-gray-700/50') },
        React.createElement("div", { className: "absolute inset-0 bg-gradient-to-r ".concat(tab.gradient, " opacity-0 group-hover:opacity-10 transition-opacity duration-300") }),
        React.createElement("div", { className: "relative z-10 transition-transform duration-300 ".concat(activeTab === tab.id ? 'scale-110' : 'group-hover:scale-110') }, tab.icon),
        React.createElement("span", { className: "relative z-10 hidden md:inline" }, tab.label),
        activeTab === tab.id && (React.createElement("div", { className: "absolute bottom-0 left-1/2 transform -translate-x-1/2 w-3/4 h-1 bg-white/40 rounded-t-full" })))); })));
};
export default SettingsTabs;
